<script lang="ts">
	export let name: string;

	import Game from "./components/Game.svelte";
</script>

<main>
	<Game></Game>
</main>

<style>

</style>
